import React, { Component, useEffect } from 'react';

//for get images
import * as img from '../../lib/images';
import * as env from '../../lib/environment';
//import components
import NavBar from '../../Components/NavBar';
import TechBox from '../../Components/TechBox';
import MyButton from '../../Components/button';
import Footer from '../../Components/footer';
import HeaderSection from '../../Components/headerSection';
import OurStorySection from '../../Components/ourStorySection';
import OurProductSection from '../../Components/ourProductSection';
import Storage from '../../Components/storage';
//homepage scss file
import './homePage.scss'


class HomePage extends Component {
    constructor(props) {
        super(props);
        this.ourStoryRef = React.createRef();
        this.ourProductRef = React.createRef();
        this.ourTechRef = React.createRef();
        this.contactRef = React.createRef();
    }
        state = {
            isMobile: window.screen.width <= 768,
        }
        updateDimensions() {
            this.setState({
                isMobile: window.screen.width <= 768,
            })
        }
        // setOurStoryRef = (ref,name) => {
        //     this[name] = ref;
        // }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    scrollToMyRef = (refName) =>  {
        console.log("Hi",refName)
         window.scrollTo({ behavior: 'smooth', top: this[refName].current.offsetTop }) 
         }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render() {
        // console.log(this.state.isMobile);
        let dummyData = [
            { image: img.DEVELOPING, name: "Developing", desciption: "Lorem ipsum dolor sit amet, consectetur adipi elit, sed do eiusmod tempor" },
            { image: img.PROCESS_WE_FOLLOW, name: "Process We Follow", desciption: "Lorem ipsum dolor sit amet, consectetur adip elit, sed do eiusmod tempor" },
            { image: img.OUR_TEAM, name: "Our Team", desciption: "Lorem ipsum dolor sit amet, consectetur adip elit, sed do eiusmod tempor" },
            { image: img.PRODUCT_DESIGN, name: "Product Design", desciption: "Lorem ipsum dolor sit amet, consectetur adipig elit, sed do eiusmod tempor" }
        ]
        return (

            <div className="mainPageContainer">
                <NavBar scrollToMyRef = {this.scrollToMyRef}  isMobile={this.state.isMobile} />
                <div className="p-0 d-flex flex-column">
                    <HeaderSection isMobile={this.state.isMobile} />
                    <OurStorySection  setOurStoryRef = {this.ourStoryRef}  isMobile={this.state.isMobile} />
                    <OurProductSection  setOurProductRef = {this.ourProductRef} isMobile={this.state.isMobile} />
                    <Storage isMobile={this.state.isMobile} />
                    <TechBox setTechRef = {this.ourTechRef} isMobile={this.state.isMobile} />
                    {this.state.isMobile ? <div className="w-100 d-flex flex-wrap headerSection">
                        <div className="d-flex flex-wrap" style={{ padding: "2rem 0rem" }}>
                            {dummyData.map(res => {
                                return (
                                    <div data-aos="flip-down" className="col-6 d-flex justify-content-center align-items-center flex-column" style={{ padding: "0rem 0rem" }}>
                                        <img style={{ width: "3.5rem" }} src={res.image} />
                                        <p className="m-0" style={{ fontWeight: "bold", padding: "1rem 0rem",textAlign:"center", color: "#212529" }}>{res.name}</p>
                                        <p style={{textAlign:"center"}}>{res.desciption}</p>
                                    </div>
                                )
                            })}
                        </div>

                        <div className="w-100 d-flex justify-content-center" style={{ padding: "2rem 0rem" }}>
                            <button style={{ borderRadius: '30px', border: "1px solid black", background: "transparent", width: '22rem', height: "3rem" }}>Let's Connect</button>
                        </div>

                    </div> : <div className="w-100 d-flex flex-wrap headerSection">
                            <div className="d-flex" style={{ padding: "2rem 0rem" }}>
                                {dummyData.map(res => {
                                    return (
                                        <div data-aos="flip-down" className="col-3" style={{ padding: "0rem 1rem" }}>
                                            <img style={{ width: "3.5rem" }} src={res.image} />
                                            <p className="m-0" style={{ fontWeight: "bold", padding: "1.5rem 0rem", color: "#212529" }}>{res.name}</p>
                                            <p>{res.desciption}</p>
                                        </div>
                                    )
                                })}
                            </div>

                            <div className="w-100 d-flex justify-content-center" style={{ padding: "2rem 0rem" }}>
                                <button style={{ borderRadius: '30px', border: "1px solid black", background: "transparent", width: '22rem', height: "3rem" }}>Let's Connect</button>
                            </div>

                        </div>}
                    <Footer  setContactRef= {this.contactRef} isMobile={this.state.isMobile} />

                </div>
            </div>
        );
    }
}

export default HomePage;
